/**
 * Decodes HTML character references in strings that are meant as plain text
 * (e.g. Funnelback snippets), not as HTML markup.
 * We avoid dangerouslySetInnerHTML: snippets are not trusted HTML and that API would risk XSS.
 */
const NAMED_ENTITIES: Record<string, string> = {
  amp: '&',
  lt: '<',
  gt: '>',
  quot: '"',
  apos: "'",
  nbsp: '\u00A0',
  copy: '\u00A9',
  reg: '\u00AE',
  trade: '\u2122',
  hellip: '\u2026',
  mdash: '\u2014',
  ndash: '\u2013',
  lsquo: '\u2018',
  rsquo: '\u2019',
  ldquo: '\u201C',
  rdquo: '\u201D',
};

const ENTITY_RE = /&(#(?:x[0-9A-Fa-f]+|[0-9]+)|[a-zA-Z][a-zA-Z0-9]*);/g;

const MAX_DECODE_PASSES = 8;

export function decodeHtmlEntitiesPlain(input: string): string {
  if (!input) {
    return input;
  }
  let prev = '';
  let out = input;
  let passes = 0;
  while (out !== prev && passes < MAX_DECODE_PASSES) {
    prev = out;
    passes += 1;
    out = out.replace(ENTITY_RE, (full, entity: string) => {
      if (entity[0] === '#') {
        const isHex = entity[1] === 'x' || entity[1] === 'X';
        const numStr = isHex ? entity.slice(2) : entity.slice(1);
        const cp = Number.parseInt(numStr, isHex ? 16 : 10);
        if (!Number.isFinite(cp) || cp < 0 || cp > 0x10ffff) {
          return full;
        }
        try {
          return String.fromCodePoint(cp);
        } catch {
          return full;
        }
      }
      const decoded = NAMED_ENTITIES[entity.toLowerCase()];
      return decoded !== undefined ? decoded : full;
    });
  }
  return out;
}
